// extracted by mini-css-extract-plugin
export default {"button":"PrimaryButton_button__idj+D"};